<template>
    <div class="stateInventory responsive-menu">
      <div class="responsive-menu__child">
        <PageHeader
          title="Active Coupon Listing"
          :links="[
            { name: 'home', label: 'Home' },
            { name: 'reports', label: 'Reports' },
            { name: 'couponReport', label: 'Coupon' },
            {
              name: 'couponListActive',
              label: 'Active Coupon Listing',
            },
          ]"
          @export="exportToCsv"
          :disableExport="!reportData"
        />
        <br class="no-print" />
        <ReportFilter
          class="no-print"
          @submit-filter="performGetReport"
          :isLoading="couponTransactions"
        />
        <div class="report-container">
          <!-- This could be a component -->
          <div class="report-body" v-if="reportData">
            <table id="table-report">
              <thead>
                <tr class="report-body__row report-body__row--header"></tr>
                <tr>
                  <th align="left">Name</th>
                  <th align="left">Updated</th>
                  <th align="left">Employee</th>
                  <th align="right">Amount</th>
                  <th align="right">%</th>
                  <th align="right">Minimum Spend</th>
                  <th align="left">One Time Use</th>
                  <th align="left">Cannabis Only</th>
                  <th align="left">Customer Only</th>
                  <th align="right">Minimum Qty</th>
                  <th align="right">Maximum Qty</th>
                  <th align="left">DateRange</th>
                  <th align="left">Start Date</th>
                  <th align="left">End Date</th>
                </tr>
              </thead>

              <tbody>
                <tr class="report-body__row"></tr>
                <tr v-for="(record, index) in reportData.records" :key="index">
                  <td>{{ record.name }}</td>
                  <td>{{ record.date }}</td>
                  <td>{{ record.employee }}</td>
                  <td align="right">{{ record.discountAmount }}</td>
                  <td align="right">{{ record.discountPercentage }}</td>
                  <td align="right">{{ record.minSpending }}</td>
                  <td align="center">{{ record.isOneTimeUse ? 'Y' : 'N' }}</td>
                  <td>{{ record.isForCannabisOnly ? 'Y' : 'N' }}</td>
                  <td>{{ record.customerOnly ? 'Y' : 'N' }}</td>
                  <td align="right">{{ record.minimumQuantity }}</td>
                  <td align="right">{{ record.maximumQuantity }}</td>
                  <td align="center">{{ record.applyDateRange ? 'Y' : 'N' }}</td>
                  <td>{{ dateFormmatter(record.startDate) }}</td>
                  <td>{{ dateFormmatter(record.endDate) }}</td>

                </tr>
              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import PageHeader from "@/components/Header/Header.vue";
  import ReportHelper from "@/lib/report/index.js";
  import { mapActions, mapGetters } from "vuex";
  import ReportFilter from "@/components/ReportFilter/ReportFilter";
  import Utilities from "@/lib/Utilities";

  export default {
    data() {
      return {
        reportData: undefined,
        Utilities,
        reportType: undefined,
        selectedPeriod: undefined,
        selectedReportFor: undefined,
        selectedReportSaleType: undefined,
        filterDropdown: undefined,
      };
    },
    components: {
      PageHeader,
      ReportFilter,
    },
    created: function () {
      this.setPageTitle("Active Coupon Listing");
    },
    mounted: function () {
      const today = new Date();
      this.selectedPeriod = {
        from: new Date(new Date().setDate(today.getDate() - 7)),
        to: today,
      };
    },
    computed: {
      ...mapGetters({
        loadingStatus: "reports/loadingStatus",
        couponTransactions: "reports/couponTransactions",
      }),
    },
    methods: {
      ...mapActions({
        getCouponTransactions: "reports/getCouponTransactions",
      }),

      dateFormmatter(date) {
        return Utilities.formatDate(date);
      },

      performGetReport(filter) {
        let reportType = "couponListActive";
        this.getCouponTransactions({
          reportType,
          ...filter,
          positiveCallback: (data) => {
            this.reportData = data;
          },
        });
      },
      exportToCsv() {
        var table = document.getElementById("table-report");
        ReportHelper.exportToExcel(table, "couponListActive");
      },
    },
  };
  </script>

  <style lang="scss">
  @import "./_couponListActive.scss";